// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EyBma","label":"styles_label__3McnC"};